import { render, staticRenderFns } from "./stockList.vue?vue&type=template&id=f463c22e&scoped=true"
import script from "./stockList.vue?vue&type=script&lang=js"
export * from "./stockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f463c22e",
  null
  
)

export default component.exports